<template>
    <div class="brand-page">
        <!-- PC端显示 -->
        <div class="brand-selection" v-if="menuPage === 'computer'">
            <div class="desc-title">
                <div class="title">{{brandDesc.title}}</div>
                <div class="upzip">
                    {{brandDesc.desc}}
                    <a class="upzip" href="https://yasuo.360.cn/" target="_blank">360压缩</a>
                </div>
            </div>
            <div class="brand-list">
                <div class="list-child"
                    v-for="item in brandList"
                    :key="item.id"
                    @click="changRoute(item.route)">
                    <div class="desc">{{item.value}}</div>
                    <img :src="item.imgUrl" :alt="item.value"/>
                </div>
            </div>
        </div>
        <!-- 移动端显示 -->
        <div class="phone-page" v-if="menuPage === 'phone'">
            <div class="title">{{brandDesc.title}}</div>
            <div class="remind">{{brandDesc.subtitle}}</div>
            <div class="brand-list">
                <div class="list-child"
                    v-for="item in brandList"
                    :key="item.id"
                    @click="changRoute(item.route)">
                    <div class="desc">{{item.value}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default  {
    name: 'BrandPage',
    data () {
        return {
            // 时间戳
            timeStamp: 0,
            menuPage: 'computer',
            brandDesc: {},
            brandList: []
        }
    },
    created () {
        // 获取时间戳
        this.getTimeStamp()
        this.requestBrand()
        this.changeMenu()
    },
    mounted () {
        window.addEventListener('resize', this.resize)
    },
    methods: {
        getTimeStamp () {
            this.timeStamp = new Date().getTime()
            // console.log(this.timeStamp)
        },
        // 获取静态json文件数据
        requestBrand () {
            this.$http.get('/mock/brand.json', {
                params: {
                    timeStamp: this.timeStamp
                }
            })
                .then((res) => {
                    this.brandList = res.data.data.brandImgList
                    this.brandDesc = res.data.data.tooltipInfo
                })
        },
        changRoute (val) {
            this.$emit('change', val)
        },
        changeMenu () {
            var screenwidth = document.documentElement.clientWidth
            if (screenwidth > 900) {
                this.menuPage = 'computer'
            } else {
                this.menuPage = 'phone'
            }
        },
        resize () {
            this.changeMenu()
        }
    }
}
</script>

<style lang="scss" scoped>
.brand-page {
    width: 100%;
    background: #409EFF;
    // height: calc(100vh - 61px);
    .brand-selection {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        width: 960px;
        height: 100%;
        .desc-title {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .title {
                height: 50px;
                line-height: 50px;
                color: #fff;
                font-size: 55px;
                font-weight: bold;
                letter-spacing: 5px;
            }
            .upzip {
                margin-top: 12px;
                height: 20px;
                line-height: 20px;
                color: #fff;
                font-size: 16px;
                a {
                    font-size: 12px;
                    font-weight: bold;
                    color: #fff000;
                    text-decoration: none;
                }
            }
        }
        .brand-list {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            // justify-content: center;
            align-items: center;
            margin-top: 30px;
            margin-left: -30px;
            width: 960px;
            .list-child {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin: 0 0 10px 30px;
                width: 30%;
                background: #fff;
                border-radius: 3px;
                cursor: pointer;
                img {
                    width: 260px;
                    height: 160px;

                }
                .desc {
                    margin-top: 10px;
                    height: 40px;
                    line-height: 40px;
                    color: #409EFF;
                    font-size: 30px;
                    font-weight: bold;
                    text-align: center;
                    letter-spacing: 5px;
                }
            }
        }
    }
    .phone-page {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        .title {
            height: 40px;
            line-height: 40px;
            color: #fff;
            font-size: 40px;
            font-weight: bold;
            letter-spacing: 5px;
        }
        .remind {
            margin-top: 15px;
            height: 30px;
            line-height: 30px;
            color: #fff;
            font-size: 20px;
        }
        .brand-list {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            margin: 10px 30px 0;
            .list-child {
                margin-top: 15px;
                width: 45%;
                height: 50px;
                line-height: 50px;
                text-align: center;
                color: #409EFF;
                font-size: 30px;
                font-weight: bold;
                letter-spacing: 5px;
                background: #fff;
                border-radius: 3px;
                cursor: pointer;
                .desc {
                    height: 50px;
                    line-height: 50px;
                    color: #409EFF;
                    font-size: 25px;
                    font-weight: bold;
                    text-align: center;
                    letter-spacing: 5px;
                }
            }
        }
    }
}
</style>
